const POI_SHOWN_ADDRESS_SUGGESTIONS = 'SA_poi_shown_address_suggestions';
const POI_SELECTED_ADDRESS_SUGGESTION = 'SA_poi_selected_address_suggestion';
const POI_DETECTED_INCOMPLETE_ADDRESS_SUGGESTIONS =
  'SA_poi_detected_incomplete_address_suggestions';

const addresses = {
  shownAddressSuggestions: ({
    numberOfAddressSuggestions,
    suggestionType,
  }) => ({
    eventName: POI_SHOWN_ADDRESS_SUGGESTIONS,
    eventData: {
      numberOfAddressSuggestions,
      suggestionType,
    },
  }),
  selectedAddressSuggestion: ({
    selectedAddressSuggestion,
    selectedAddressRank,
    totalNumberOfAddresses,
    suggestionType,
  }) => ({
    eventName: POI_SELECTED_ADDRESS_SUGGESTION,
    eventData: {
      selectedAddressSuggestion,
      selectedAddressRank,
      totalNumberOfAddresses,
      suggestionType,
    },
  }),
  detectedIncompleteAddressSuggestions: ({
    totalNumberOfAddresses,
    numberOfIncompleteAddresses,
    suggestionType,
  }) => ({
    eventName: POI_DETECTED_INCOMPLETE_ADDRESS_SUGGESTIONS,
    eventData: {
      totalNumberOfAddresses,
      numberOfIncompleteAddresses,
      suggestionType,
    },
  }),
};

export default addresses;
